import { render, staticRenderFns } from "./soundAdd.vue?vue&type=template&id=15a1885e&scoped=true&"
import script from "./soundAdd.vue?vue&type=script&lang=js&"
export * from "./soundAdd.vue?vue&type=script&lang=js&"
import style0 from "./soundAdd.vue?vue&type=style&index=0&id=15a1885e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a1885e",
  null
  
)

export default component.exports